import { FullContainer } from '@gorila-shared-ui/components';
import { Tab, Tabs } from 'baseui/tabs-motion';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useStyles } from '../../../hooks/useStyles';
import { Events } from '../../account/events/Events';
import { Profile } from '../../account/profile/Profile';

export function AccountPage() {
  const [activeKey, setActiveKey] = useState(0);
  const {
    overrides: { tabOverflowOverrides, tabOverrides, tabsOverrides },
  } = useStyles();
  const { tab } = useParams();

  useEffect(() => {
    if (!tab) return;
    setActiveKey(+tab);
  }, [tab]);

  return (
    <FullContainer verticalFlex>
      <Tabs
        activeKey={activeKey}
        onChange={({ activeKey }) => {
          setActiveKey(activeKey as number);
        }}
        activateOnFocus
        overrides={tabsOverrides}
      >
        <Tab
          title="Mi perfil"
          overrides={tabOverflowOverrides}
        >
          <Profile />
        </Tab>
        <Tab
          title="Eventos"
          overrides={tabOverrides}
        >
          <Events />
        </Tab>
      </Tabs>
    </FullContainer>
  );
}
